import { inject as service } from '@ember/service';
import ApplicationAdapter from 'cio/adapters/application';
import EnvironmentService from 'cio/services/environment';

export default class WarehouseSyncAdapter extends ApplicationAdapter {
  @service environment!: EnvironmentService;

  pathForType(_: string | number): string {
    // There's only one warehouse sync for any workspace, so the URLs are singularized.
    return `environments/${encodeURIComponent(this.environment.current.id!)}/warehouse_sync`;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'warehouse-sync': WarehouseSyncAdapter;
  }
}
